import React from 'react';
import { Box, Flex } from '@skin-seoul/design-system';
import ProductCardWishListButton from '../components/WishListButton';
import ProductImage from '../components/ProductImage';

type ProductCardImageProps = {
  topSlot?: React.ReactNode;
  bottomSlot?: React.ReactNode;
};

const VerticalProductCardImage = ({ topSlot, bottomSlot }: ProductCardImageProps) => {
  return (
    <Box
      borderRadius="8px"
      background="neutral.50"
      overflow="hidden"
      height={{
        base: '172px',
        tablet: '224px',
      }}
      maxHeight={{
        base: '172px',
        tablet: '224px',
      }}
      boxSizing="border-box"
      padding={{
        base: '20px',
        tablet: '44px',
      }}
      position="relative"
      width="100%"
      minWidth={0}
    >
      <Flex position="absolute" zIndex={2} top={0} left={0} width="100%">
        <>{topSlot}</>
        <ProductCardWishListButton />
      </Flex>
      <ProductImage />
      <Flex position="absolute" bottom={0} zIndex={2} left={0} width="100%">
        <>{bottomSlot}</>
      </Flex>
    </Box>
  );
};

export default VerticalProductCardImage;
